import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import {
  GET_ROLES,
  GET_ROLE_DETAIL,
  ADD_NEW_ROLE,
  UPDATE_ROLE,
} from "./actionTypes"
import {
  getRolesSuccess,
  getRolesFail,
  getRoleDetailSuccess,
  getRoleDetailFail,
  addRoleFail,
  addRoleSuccess,
  updateRoleSuccess,
  updateRoleFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getRoles,
  getRolesDetails,
  addNewRole,
  updateRole,
} from "helpers/backend_helper"

function* fetchRoles(payload) {
  try {
    console.log('payload', payload);
    const response = yield call(getRoles, payload.payload)
    yield put(getRolesSuccess(response))
  } catch (error) {
    yield put(getRolesFail(error))
  }
}

function* fetchRoleDetail({ RoleId }) {
  try {
    const response = yield call(getRolesDetails, RoleId)
    yield put(getRoleDetailSuccess(response))
  } catch (error) {
    yield put(getRoleDetailFail(error))
  }
}

function* onUpdateRole({ payload: Role }) {
  try {
    const response = yield call(updateRole, Role)
    if (response?.success) {
      yield put(updateRoleSuccess(response))
    } else {
      yield put(updateRoleFail(response?.message))
    }
  } catch (error) {
    yield put(updateRoleFail(error))
  }
}

function* onAddNewRole({ payload: Role }) {
  try {
    const response = yield call(addNewRole, Role)
    yield put(addRoleSuccess(response))
  } catch (error) {
    yield put(addRoleFail(error))
  }
}

function* RolesSaga() {
  yield takeEvery(GET_ROLES, fetchRoles)
  yield takeEvery(GET_ROLE_DETAIL, fetchRoleDetail)
  yield takeEvery(ADD_NEW_ROLE, onAddNewRole)
  yield takeEvery(UPDATE_ROLE, onUpdateRole)
}

export default RolesSaga
